/**
 * SOVRANOVA — Today's check-in (System 2 UI)
 * A ~20-second daily self-report. Deliberately NOT called "Wellbeing Check-in":
 * that name belongs to the PHQ-9 / GAD-7 assessment. This is the light daily
 * pulse that feeds the greeting's "how you were earlier" hook, the streak, and
 * care routing. Self-report only — no diagnosis, no clinical label.
 * Renders NOTHING if /api/checkin is off or unreachable, so it can never break
 * the dashboard.
 */
import { useState, useEffect } from 'react'
import { api } from '../../services/api'

const ENERGY = [
  { key: 'low',  emoji: '🌧', label: 'Low' },
  { key: 'okay', emoji: '🌤', label: 'Okay' },
  { key: 'good', emoji: '☀️', label: 'Good' },
]

export function CheckInCard({ onDone }) {
  const [state, setState]         = useState(null)
  const [saving, setSaving]       = useState(false)
  const [justSaved, setJustSaved] = useState(false)
  const [hidden, setHidden]       = useState(false)

  useEffect(() => {
    api.get('/checkin').then(setState).catch(() => setHidden(true))
  }, [])

  if (hidden || !state) return null
  const done = state.slot_done || justSaved

  const submit = async (energy) => {
    if (saving) return
    setSaving(true)
    try {
      await api.post('/checkin', { energy, slot: state.slot })
    } catch (_) {
      // Offline writes queue and replay — still "done" from the person's view.
    } finally {
      setJustSaved(true)
      setSaving(false)
      onDone?.()
    }
  }

  return (
    <div style={s.card}>
      <p style={s.label}>TODAY'S CHECK-IN</p>
      {done ? (
        <p style={s.done}>Thanks for checking in — that's the whole thing. You're complete for today.</p>
      ) : (
        <>
          <p style={s.prompt}>{state.prompt}</p>
          <div style={s.row}>
            {ENERGY.map(e => (
              <button key={e.key} style={s.opt} disabled={saving} onClick={() => submit(e.key)}>
                <span style={s.optEmoji}>{e.emoji}</span>
                <span style={s.optLabel}>{e.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

// Organic restyle (Board D1, 2026-08-13) — sage card, white pill options.
const s = {
  card:{ background:'var(--og-s100, #f0fae1)', border:'none', borderRadius:'var(--og-rl, 28px)', padding:'1.1rem 1.3rem' },
  label:{ fontSize:'0.66rem', letterSpacing:'0.12em', color:'var(--og-s800, #3d472b)', textTransform:'uppercase', marginBottom:'0.5rem', fontWeight:700 },
  prompt:{ fontFamily:'var(--og-fh, Georgia, serif)', fontSize:'1.1rem', color:'var(--og-s900, #272e1b)', lineHeight:1.4, marginBottom:'0.8rem' },
  done:{ fontSize:'0.9rem', color:'var(--og-n800, #474238)', lineHeight:1.6 },
  row:{ display:'flex', gap:'0.6rem', flexWrap:'wrap' },
  opt:{ display:'flex', alignItems:'center', gap:'0.45rem', background:'#fff', border:'none', borderRadius:'999px', padding:'0.65rem 1.3rem', cursor:'pointer', fontFamily:'inherit', minHeight:44 },
  optEmoji:{ fontSize:'1.05rem' },
  optLabel:{ fontSize:'0.88rem', fontWeight:600, color:'var(--og-text, #201e1d)' },
}
